interface Props {
  schema: Record<string, unknown> | Record<string, unknown>[];
}
const GoogleSchema = ({
  schema
}: Props) => {
  return <script type='application/ld+json'
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: JSON.stringify(schema)
  }} data-sentry-component="GoogleSchema" data-sentry-source-file="google-schema.tsx" />;
};
export default GoogleSchema;